import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { State as RootState } from '@occc-app/rootRedux';

import { actions, State, LimitKeys } from './redux';
import { LimitType, LimitConfiguration } from './components';

type LimitTypes = {
  type: LimitKeys;
  name: string;
  description: string;
};

type SlicedReduxState = State & { requiresActivation: boolean };
type Actions = typeof actions;
type Props = SlicedReduxState & Actions;
class CreateLimits extends React.Component<Props, {}> {
  renderLimitTypes() {
    const { limitConfigurationUpdate, limitToggleUpdate, requiresActivation } = this.props;

    const verb = requiresActivation ? 'activation' : 'fulfillment';
    const noun = requiresActivation ? 'activation' : 'award';

    const limitTypes: LimitTypes[] = [
      {
        // tslint:disable-next-line
        description: `Limits ${verb} based on the number of times the offer has generated an ${noun} across all memberships`,
        type: 'globalLimit',
        name: 'global',
      },
      {
        // tslint:disable-next-line
        description: `Limits ${verb} based on the number of times the offer has generated an ${noun} for a single membership`,
        type: 'membershipLimit',
        name: 'per-member',
      },
    ];

    return limitTypes.map((limitType) => {
      const { description, type, name } = limitType;
      const { active } = this.props[type];
      const fieldDisabled = () => false;

      return (
        <LimitType
          key={type}
          description={description}
          limitToggleUpdate={limitToggleUpdate}
          type={type}
          isActive={active}
          name={name}
        >
          <LimitConfiguration
            {...this.props[type]}
            fieldDisabled={fieldDisabled}
            limitConfigurationUpdate={limitConfigurationUpdate}
            name={name}
          />
        </LimitType>
      );
    });
  }
  render() {
    return <Box>{this.renderLimitTypes()}</Box>;
  }
}

type MapStateToProps = (state: RootState) => SlicedReduxState;
const mapStateToProps: MapStateToProps = ({
  offer: {
    constraints: {
      requiresActivation: { active },
    },
    limits,
  },
}) => ({
  ...limits,
  requiresActivation: active,
});

export default connect(mapStateToProps, actions)(CreateLimits);
